import React from "react";
import "./Button.css";

function Button(props) {
  return (
    <div className="Button-container">
      <div
        className="Button-shadow"
        style={{
          position: "absolute",
          backgroundColor: "black",
          height: "100%",
          width: "100%",
        }}
      />
      <div className="Button">{props.children}</div>
    </div>
  );
}

export default Button;
